import axios from 'axios';

import React, { Component, useContext, useEffect, useRef, useState } from 'react';
import { Button, ButtonGroup, RadioGroup, Radio } from "@blueprintjs/core";

import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

import $ from 'jquery'
import 'jquery-ui/ui/widgets/sortable';
import PageContext from '../Context/PageContext';

import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import { AddPoint, AddTraceGPX, CalcItineraire, DeleteTrace, calcElevationProfile } from "../Util/ActivitesUtil"
import ContentEditable from 'react-contenteditable';
import Helper from '../Component/Helper';
import { createOneValueAndContextItinerairetAction, createOneValueItinerairetAction, createPointAndTraceItinerairetAction, createTraceGPXItinerairetAction, deletePointAndTraceItinerairetAction, selectTransportItinerairetAction } from '../history/itineraire.history';

export default function ActivitesSection() {
    const { addMapSource, addMapLayer, mapListEtape, traceStyle, traceLayout, mapListPoint, addMapListPoint, mapListTrace, addMapListTrace, setElevationData,
        elevationData, setIsElevationPresent, objItems, removeItem, setChartRef, history, getMapListPoint, getMapListTrace } = useContext(PageContext);
    const allContext = useContext(PageContext);

    const [isSubSectionOpenCatalogue, setIsSubSectionOpenCatalogue] = useState(false);
    const [isLoader, setIsLoader] = useState(false);

    function jQuerycode() {
        $("#sortable").sortable({
            start: function (event, ui) {
                var start_pos = ui.item.index();
                ui.item.data('start_pos', start_pos);
            },
            update: function (event, ui) {
                updatePositionTrace();
            }
        });
    }

    function updatePositionTrace() {

        $('.etape').each(function (index) {

            $(this).find('div > .etape-number')[0].textContent = (index + 1).toString();
            var itemListEtape = mapListEtape.find((x) => x.id === $(this)[0].id);

            //set position to context
            itemListEtape['position'] = index;
        });
    }

    useEffect(() => {
        //jQuerycode();

    }, [mapListEtape])

    function onFileUpload() {
        $('#upload-file-gpx').click();
    }

    function fileActionUpload(event: any) {

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "gpx",
            event.target.files[0],
            event.target.files[0].name
        );

        //active loader
        setIsLoader(true);

        // Request made to the backend api
        axios.post(process.env.REACT_APP_URL_BACK + "/upload-gpx", formData).then((response) => {

            if (response.status == 200) {

                setIsLoader(false);

                var { point1, point2 } = AddTraceGPX("GPX", response.data.gpx.features[0], response.data.gpx, "", response.data.cityStart.city, response.data.cityEnd.city, null, null,
                    {
                        addMapSource, addMapLayer, traceStyle, traceLayout,
                        mapListPoint, addMapListPoint, mapListTrace, addMapListTrace, setElevationData,
                        elevationData, setIsElevationPresent, objItems, removeItem, setChartRef
                    })

                //on passe allContext, comme ça pas à gérer
                let action = createTraceGPXItinerairetAction({
                    point1: point1,
                    point2: point2,
                    route: response.data.gpx.features[0],
                    sourceData: response.data.gpx,
                    typeTransport: "",
                    depart: response.data.cityStart.city,
                    arrivee: response.data.cityEnd.city,
                    context: allContext
                });

                history.add(action);
            }

        }, (error) => {
            setIsLoader(false);
            console.log(error);
        });
    }

    /* GEOCODE DOC
   https://github.com/mapbox/mapbox-gl-geocoder/blob/main/API.md#on */
    const geocoder1 = new MapboxGeocoder({
        accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN != null ? process.env.REACT_APP_MAPBOX_ACCESS_TOKEN : "",
        mapboxgl: mapboxgl,
        placeholder: 'Ajouter une ville',
        language: 'fr'

    });

    geocoder1.on('result', function (result) {

        var newPoint = AddPoint(result.result.place_name, result.result.geometry.coordinates, 'Recherche', null, { mapListPoint, addMapListPoint });

        if (addMapListPoint != null) addMapListPoint([newPoint]);

        if (mapListPoint.length > 0) {
            CalcItineraire(mapListPoint[mapListPoint.length - 1], newPoint, "driving", null, null,
                {
                    addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTrace, setElevationData,
                    elevationData, setIsElevationPresent,
                    objItems, removeItem, setChartRef
                })
        }

        //on efface le champs recherche après validation
        geocoder1.clear();

        //on passe allContext, comme ça pas à gérer
        let action = createPointAndTraceItinerairetAction({
            target: "add_point",
            item: newPoint,
            snapshotMapListPoint: mapListPoint,
            snapshotMapListTrace: mapListTrace,
            context: allContext
        });

        history.add(action);
    })

    useEffect(() => {

        geocoder1.addTo('#geocoder1');

        /* to avoid multiple render */
        return () => {
            const parentContainer1 = document.getElementById("geocoder1");
            const geoChild = document.getElementsByClassName(
                "mapboxgl-ctrl-geocoder"
            );

            if (!parentContainer1 || !geoChild) return;
            parentContainer1.removeChild(geoChild[0]);
        };
    }, [mapListPoint, mapListTrace]);

    //reset value, if the upload is the same
    function onInputClick(event: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        const element = event.target as HTMLInputElement
        element.value = ''
    }


    return (
        <div>
            {!isSubSectionOpenCatalogue &&
                <div>
                    <div className="act-head">

                        <h2>Itinéraire de l'affiche</h2>
                        <div className='subtitle-section'>
                            <ButtonGroup vertical={false} fill={false}>
                                <label htmlFor="upload">
                                    <button className="main-button2" onClick={onFileUpload} >
                                        <div className='svg-icone-button'><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 24 24" ><g><path fill="currentColor" fillRule="evenodd" d="M4 1a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-8L9.879 1.879A3 3 0 0 0 7.757 1zm8 8a1 1 0 0 1 1 1v4.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 14.586V10a1 1 0 0 1 1-1z" clipRule="evenodd" opacity="1"></path></g></svg></div>
                                        Importer GPX
                                    </button>
                                    <input type="file" id="upload-file-gpx" style={{ "display": "none" }} onChange={fileActionUpload} onClick={onInputClick} accept='.gpx' />
                                </label>
                                {isLoader && <div className="loader"></div>}

                            </ButtonGroup>
                            <Helper text="Crée ton itinéraire en ajoutant tes étapes une par une. Soit en recherchant tes lieux, soit en ajoutant tes tracés GPX. Tu peux combiner les deux !" />
                        </div>
                    </div>
                    <div>
                        <div className="recherche-sub start">
                            <div id="geocoder1" className="geocoder"></div>
                        </div>
                    </div>
                    <div >
                        <CardEtapeList />

                    </div>
                </div>
            }

            {isSubSectionOpenCatalogue &&
                <div className='sub-section-act'>
                    <button className="main-button2" onClick={() => setIsSubSectionOpenCatalogue(false)} >
                        <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/back.svg"}></img>
                        Retour
                    </button>
                    <CatalogueSearch fn={setIsSubSectionOpenCatalogue} />
                </div>}
        </div>
    );
}

function CardEtapeList() {

    const { mapListPoint, mapListTrace } = useContext(PageContext);

    var listPointTrace: any = [];
    console.log()

    for (var index = 0; index < mapListPoint.length; index++) {
        var point1: any; var point2: any; var point_1: any; var trace: any; var trace_1: any;

        point1 = mapListPoint[index];
        point2 = mapListPoint[index + 1] != undefined ? mapListPoint[index + 1] : null;

        if (point1 != null && point2 != null) trace = mapListTrace.find(elem => elem.point1 === point1.id && elem.point2 === point2.id);
        else trace = null;

        if (point1 != null) {
            var out = < CardEtape item={point1} index={index} key={point1.id} />;
            listPointTrace.push(out);
        }

        if (trace != null) {
            var out = <CardTrace trace={trace} key={trace.id} />;
            listPointTrace.push(out);
        }

    }

    return (
        <div id="sortable" className="act-body">
            {listPointTrace}
        </div>
    )
}

function CardEtape(props: any) {

    const { setOpenAbsoluteMenuSection, openAbsoluteMenuSection, getMapListPoint, getMapListTrace, removeMapListTrace,
        removeMapListPoint, addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTrace, setElevationData,
        elevationData, setIsElevationPresent, objItems, removeItem, setChartRef, history, mapListPoint, mapListTrace } = useContext(PageContext);
    const allContext = useContext(PageContext);

    const index = props.index;
    const item = props.item;

    const [isMarkerVisible, setIsMarkerVisible] = useState(item.visible);
    const [label, setLabel] = useState(item.label);

    //a priori le state n'est pas tout le temps rendu par react car c'est string item.label, type non primitif
    //pour palier à ce cas qui ne fonctionne pas comme les autres, on passe la fontion setLabel
    /*useEffect(() => {
        setLabel(item.label)
    }, [item.label]);*/
    useEffect(() => {
        setIsMarkerVisible(item.visible)
    }, [item.visible]);

    function handleTextChange(e: any) {
        //innerText → texte visible, sans HTML, respecte les retours à la ligne
        let from = item.label;

        item.markerTxt.getElement().textContent = e.currentTarget.innerText;
        item.label = e.currentTarget.innerText;

        setLabel(e.currentTarget.innerText);

        //history
        let action = createOneValueAndContextItinerairetAction({
            target: "write-label",
            item: item,
            from,
            to: item.label,
            context: { setLabel }
        });

        if (!Object.is(from, item.label)) {
            history.add(action);
        }
    }

    const handlePaste = (e: any) => {
        e.preventDefault();
        const text = e.clipboardData.getData("text/plain");
        //permet de set immediatamment le texte brut sans le style qu'il pourrait y avoir en copier collant
        e.currentTarget.textContent = text;
    }

    function openAbsoluteMenuSectionSection(item: any) {
        if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection(openAbsoluteMenuSection === 'marker-' + item.id ? '' : 'marker-' + item.id)
    }

    function markerVisible() {

        let from = false;
        if (isMarkerVisible) {
            item.marker.getElement().style.visibility = 'hidden';
            item.markerTxt.getElement().style.visibility = 'hidden';
            item.visible = false;
            setIsMarkerVisible(false);
            from = true;
        }
        else {
            item.marker.getElement().style.visibility = 'visible';
            item.markerTxt.getElement().style.visibility = 'visible';
            item.visible = true;
            setIsMarkerVisible(true);
            from = false;
        }

        let action = createOneValueItinerairetAction({
            target: "marker-visible",
            item: item,
            from,
            to: !from
        });

        history.add(action);

    }

    return (
        <div className='etape-cont'>
            <div className='etape-top'>
                <div className='etape-child-first'>
                    <span className="etape-number">{index + 1}</span>
                </div>
                <div className=''>
                    <span>{item.city}</span>
                </div>
                <div className='etape-top-right'>
                    <div onClick={() => {
                        //on ferme le menu si il est ouvert, avant de supprimer, pour éviter undefined
                        if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('');
                        DeleteTrace(item, true, {
                            getMapListPoint, removeMapListTrace, removeMapListPoint,
                            addMapSource, addMapLayer, traceStyle, traceLayout, getMapListTrace, addMapListTrace, setElevationData,
                            elevationData, setIsElevationPresent, objItems, removeItem, setChartRef
                        })
                        //on passe allContext, comme ça pas à gérer
                        let action = deletePointAndTraceItinerairetAction({
                            target: "delete_point",
                            item: item,
                            snapshotMapListPoint: mapListPoint,
                            snapshotMapListTrace: mapListTrace,
                            context: allContext
                        });

                        history.add(action);

                    }
                    }>
                        <img className="icone-button-act" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/trash-can.svg"}></img>
                    </div>
                    <div onClick={() => markerVisible()}>
                        {isMarkerVisible ? <img className="icone-button-act" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/view.svg"}></img> :
                            <img className="icone-button-act" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/hide.svg"}></img>}
                    </div>
                </div>
            </div>
            <div className='etape-middle'>
                <div className='etape-child-first etape-rond-cont'><img className="icone-pin-act" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/pin.svg"}></img></div>
                <div>
                    <ContentEditable key={item.id} className="edit-label-name"
                        html={label} // innerHTML of the editable div
                        onChange={(e) => handleTextChange(e)} // handle innerHTML change
                        onPaste={(e) => handlePaste(e)} // handle innerHTML change
                        tagName='div' // Use a custom HTML tag (uses a div by default)
                        placeholder={"Label étape"}
                    />
                </div>
            </div>
            <div className='etape-bottom'>
                <div>
                    <button className="main-button2 btn-edit-etape" onClick={() => openAbsoluteMenuSectionSection(item)} >
                        Éditez le style
                        <div className='svg-icone-button'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.8313 4.66834L15.3313 2.16834C15.2434 2.08056 15.1242 2.03125 15 2.03125C14.8758 2.03125 14.7566 2.08056 14.6687 2.16834L7.16875 9.66834C7.08082 9.75616 7.03136 9.87531 7.03125 9.99959V12.4996C7.03125 12.6239 7.08064 12.7431 7.16854 12.831C7.25645 12.919 7.37568 12.9683 7.5 12.9683H10C10.1243 12.9682 10.2434 12.9188 10.3313 12.8308L17.8313 5.33084C17.919 5.24295 17.9683 5.12381 17.9683 4.99959C17.9683 4.87537 17.919 4.75623 17.8313 4.66834ZM9.80547 12.0308H7.96875V10.1941L13.125 5.03787L14.9617 6.87459L9.80547 12.0308ZM15.625 6.21131L13.7883 4.37459L15 3.16287L16.8367 4.99959L15.625 6.21131ZM17.3438 9.99959V16.2496C17.3438 16.5397 17.2285 16.8179 17.0234 17.023C16.8183 17.2281 16.5401 17.3433 16.25 17.3433H3.75C3.45992 17.3433 3.18172 17.2281 2.9766 17.023C2.77148 16.8179 2.65625 16.5397 2.65625 16.2496V3.74959C2.65625 3.45951 2.77148 3.18131 2.9766 2.97619C3.18172 2.77107 3.45992 2.65584 3.75 2.65584H10C10.1243 2.65584 10.2435 2.70522 10.3315 2.79313C10.4194 2.88104 10.4688 3.00027 10.4688 3.12459C10.4688 3.24891 10.4194 3.36814 10.3315 3.45604C10.2435 3.54395 10.1243 3.59334 10 3.59334H3.75C3.70856 3.59334 3.66882 3.6098 3.63951 3.6391C3.61021 3.6684 3.59375 3.70815 3.59375 3.74959V16.2496C3.59375 16.291 3.61021 16.3308 3.63951 16.3601C3.66882 16.3894 3.70856 16.4058 3.75 16.4058H16.25C16.2914 16.4058 16.3312 16.3894 16.3605 16.3601C16.3898 16.3308 16.4062 16.291 16.4062 16.2496V9.99959C16.4062 9.87527 16.4556 9.75604 16.5435 9.66813C16.6315 9.58022 16.7507 9.53084 16.875 9.53084C16.9993 9.53084 17.1185 9.58022 17.2065 9.66813C17.2944 9.75604 17.3438 9.87527 17.3438 9.99959Z" fill="currentColor" /></svg>
                        </div>

                    </button>
                </div>
            </div>
        </div>
    );
}

function CardTrace(props: any) {

    const { addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTrace, mapListPoint,
        setOpenAbsoluteMenuSection, openAbsoluteMenuSection, setElevationData, elevationData,
        setIsElevationPresent, objItems, removeItem, setChartRef, history } = useContext(PageContext);


    const trace = props.trace;

    const [typeTransport, setTypeTransport] = useState(trace.type != '' ? trace.type : "driving");
    const [isTraceVisible, setIsTraceVisible] = useState(trace.visible);

    //pour action après undo redo
    useEffect(() => {
        if (trace.type != 'none') {
            traceVisibleB(true);
        }
        else {
            traceVisibleB(false);
            //traceVisible();
        }
        setTypeTransport(trace.type)
    }, [trace.type]);

    function selectTypeTransport(type: any) {

        let from = trace.type;

        const point1 = mapListPoint.find((p) => p.id === trace.point1);
        const point2 = mapListPoint.find((p) => p.id === trace.point2);

        if (type != typeTransport && type != 'none') {

            //Ici, dans AddTrace on set trace.type
            CalcItineraire(point1, point2, type, trace, null,
                {
                    addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTrace, setElevationData,
                    elevationData, setIsElevationPresent, objItems, removeItem, setChartRef
                })

            setTypeTransport(type);
            traceVisibleB(true);

        }
        else if (type != typeTransport && type === 'none') {
            //c'est le meme bouton que caché oeil?
            traceVisible();
            setTypeTransport(type);
            traceVisibleB(false)
            trace.type = 'none';

        }

            //on passe allContext, comme ça pas à gérer
            /**/let action = selectTransportItinerairetAction({
            point1: point1,
            point2: point2,
            trace: trace,
            from: from,
            to: type,
            context: {
                addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTrace, setElevationData,
                elevationData, setIsElevationPresent, objItems, removeItem, setChartRef
            }
        });

        history.add(action);

        /*calcElevationProfile(mapListTrace, setElevationData, elevationData, setIsElevationPresent,
            objItems, removeItem, setChartRef);*/
    }

    function openAbsoluteMenuSectionSection(trace: any) {
        if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection(openAbsoluteMenuSection === 'trace-' + trace.id ? '' : 'trace-' + trace.id)
    }

    function traceVisible() {
        var map = (window as any).$map;

        var l = map.getStyle().layers
        const myLayers = l.filter((x: any) => x.id === trace.id);

        if (isTraceVisible) {

            trace.visible = false;

            myLayers.forEach((element: any) => {
                map.setLayoutProperty(element.id, 'visibility', 'none');
            });

            setIsTraceVisible(false);
        }
        else {
            trace.visible = true;

            myLayers.forEach((element: any) => {
                map.setLayoutProperty(element.id, 'visibility', 'visible');
            });

            setIsTraceVisible(true);
        }

    }

    function traceVisibleB(b: boolean) {
        var map = (window as any).$map;

        var l = map.getStyle().layers
        const myLayers = l.filter((x: any) => x.id === trace.id);

        if (!b) {

            trace.visible = false;

            myLayers.forEach((element: any) => {
                map.setLayoutProperty(element.id, 'visibility', 'none');
            });

            setIsTraceVisible(false);
        }
        else {
            trace.visible = true;

            myLayers.forEach((element: any) => {
                map.setLayoutProperty(element.id, 'visibility', 'visible');
            });

            setIsTraceVisible(true);
        }

    }

    return (
        <div className='trace-cont'>
            <div className='trace-cont-dot'><img className="icone-button-act" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/dots.svg"}></img></div>
            <div className="trace" id={trace.id}>
                <div className='select-type-transport'>
                    {trace.name == 'GPX' && <div className='gpx-key-word'>{trace.name}</div>}

                    {trace.name == 'Recherche' && trace.type != '' &&
                        <div>
                            <div className={'select-type-transport-item ' + (typeTransport === 'direct' ? 'selected' : '')} onClick={() => selectTypeTransport("direct")}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 60 60"><g><path d="M9.19 35.33a4.397 4.397 0 0 0 3.56 1.81c.34 0 .7-.04 1.04-.12 3.5-.85 10.02-2.47 16.34-4.22l-3.03 7.15c-.14.31-.1.66.08.94.19.28.5.45.84.45 2.51 0 4.89-1.11 6.5-3.05 2.02-2.41 4.56-5.78 5.64-8.48.64-.22 1.25-.43 1.82-.63 6.17-2.22 9.89-3.7 11.89-5.18.94-.71 1.34-1.89 1.03-3.01a2.769 2.769 0 0 0-2.44-2.01l-3.3-.29c-1.19-.1-2.4.08-3.5.52l-12.44 4.95c-3.43-1.07-9.04-1.78-12.15-2.11-1.91-.21-3.77.47-5.1 1.85-.24.24-.34.59-.26.92s.32.6.64.72l7.14 2.5-8.13 3.23-6.11-3.77a.958.958 0 0 0-.84-.09l-2.73.92c-.3.1-.54.34-.63.65-.1.3-.04.63.15.89z" fill="currentColor" opacity="1"></path></g></svg>
                            </div>
                            <div className={'select-type-transport-item ' + (typeTransport === 'driving' ? 'selected' : '')} onClick={() => selectTypeTransport("driving")}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 512 512"><g><g data-name="13-car"><path d="M120 236a52 52 0 1 0 52 52 52.059 52.059 0 0 0-52-52Zm0 76a24 24 0 1 1 24-24 24 24 0 0 1-24 24ZM408 236a52 52 0 1 0 52 52 52.059 52.059 0 0 0-52-52Zm0 76a24 24 0 1 1 24-24 24 24 0 0 1-24 24Z" fill="currentColor" opacity="1"></path><path d="M477.4 193.04 384 176l-79.515-65.975A44.109 44.109 0 0 0 276.526 100H159.38a43.785 43.785 0 0 0-34.359 16.514L74.232 176H40a36.04 36.04 0 0 0-36 36v44a44.049 44.049 0 0 0 44 44h9.145a64 64 0 1 1 125.71 0h162.29a64 64 0 1 1 125.71 0H472a36.04 36.04 0 0 0 36-36v-35.368a35.791 35.791 0 0 0-30.6-35.592ZM180 164a12 12 0 0 1-12 12h-52.755a6 6 0 0 1-4.563-9.9l34.916-40.9a12 12 0 0 1 9.126-4.2H168a12 12 0 0 1 12 12Zm60 56h-16a12 12 0 0 1 0-24h16a12 12 0 0 1 0 24Zm94.479-43.706-114.507-.266a12 12 0 0 1-11.972-12V133a12 12 0 0 1 12-12h57.548a12 12 0 0 1 7.433 2.58l53.228 42a6 6 0 0 1-3.73 10.714Z" fill="currentColor" opacity="1"></path></g></g></svg>
                            </div>
                            <div className={'select-type-transport-item ' + (typeTransport === 'cycling' ? 'selected' : '')} onClick={() => selectTypeTransport("cycling")}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 512 512"><g><path d="M330.667 122.667c23.467 0 42.667-19.2 42.667-42.667s-19.2-42.667-42.667-42.667S288 56.533 288 80s19.2 42.667 42.667 42.667zM106.667 261.333C48 261.333 0 309.333 0 368s48 106.667 106.667 106.667 106.667-48 106.667-106.667-48.001-106.667-106.667-106.667zm0 181.334C65.067 442.667 32 409.6 32 368s33.067-74.667 74.667-74.667S181.334 326.4 181.334 368s-33.067 74.667-74.667 74.667z" fill="currentColor" opacity="1"></path><path d="M404.267 238.933v-42.667c-32 0-58.667-11.733-77.867-30.933L284.8 124.8c-6.4-7.467-17.067-12.8-28.8-12.8s-22.4 4.267-29.867 12.8l-58.667 58.667c-7.467 7.467-12.8 18.133-12.8 29.867s5.333 22.4 12.8 30.933l67.2 59.733v106.667h42.667V277.333L230.4 230.4l50.133-51.2 16 16c26.667 27.733 64 43.733 107.734 43.733z" fill="currentColor" opacity="1"></path><path d="M405.333 261.333c-58.667 0-106.667 48-106.667 106.667s48 106.667 106.667 106.667S512 426.667 512 368s-48-106.667-106.667-106.667zm0 181.334c-41.6 0-74.667-33.067-74.667-74.667s33.067-74.667 74.667-74.667S480 326.4 480 368s-33.067 74.667-74.667 74.667z" fill="currentColor" opacity="1"></path></g></svg>
                            </div>
                            <div className={'select-type-transport-item ' + (typeTransport === 'walking' ? 'selected' : '')} onClick={() => selectTypeTransport("walking")}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 24 24"><g><path fill="currentColor" d="m7.617 8.712 3.205-2.328c.36-.263.797-.398 1.243-.384a2.616 2.616 0 0 1 2.427 1.82c.186.583.356.977.51 1.182A4.992 4.992 0 0 0 19 11v2a6.987 6.987 0 0 1-5.402-2.547l-.697 3.955 2.061 1.73 2.223 6.108-1.88.684-2.04-5.604-3.39-2.845a2 2 0 0 1-.713-1.904l.509-2.885-.677.492-2.127 2.928-1.618-1.176L7.6 8.7zM13.5 5.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-2.972 13.181-3.214 3.83-1.532-1.285 2.976-3.546.746-2.18 1.791 1.5z" opacity="1" ></path></g></svg>
                            </div>
                            <div className={'select-type-transport-item ' + (typeTransport === 'none' ? 'selected' : '')} onClick={() => selectTypeTransport("none")}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 384 384"><g><path d="M192 384c105.863 0 192-86.129 192-192 0-51.328-19.96-99.55-56.207-135.793C291.543 19.961 243.328 0 192 0 86.129 0 0 86.129 0 192c0 51.328 19.96 99.55 56.207 135.793C92.449 364.039 140.672 384 192 384zm0-32c-37.39 0-72.8-12.71-101.297-36.078L315.922 90.703C339.289 119.2 352 154.61 352 192c0 88.223-71.777 160-160 160zm0-320c37.383 0 72.8 12.71 101.29 36.078L68.077 293.297C44.711 264.8 32 229.39 32 192c0-88.223 71.777-160 160-160zm0 0" fill="currentColor" opacity="1"></path></g></svg>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className='trace-edit-act' style={{ display: 'flex' }}>
                {trace.name == 'GPX' && <div onClick={() => {
                    traceVisible();
                    let action = createOneValueAndContextItinerairetAction({
                        target: "gpx-visible",
                        item: trace,
                        from : isTraceVisible,
                        to: !isTraceVisible,
                        context: { setIsTraceVisible }
                    });

                    history.add(action);
                }
                }>
                    {isTraceVisible ?
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 511.999 511.999"><g><path d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 0 0 0 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 0 0 0-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z" fill="currentColor" opacity="1"></path><path d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z" fill="currentColor" opacity="1"></path></g></svg>
                        :
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 128 128"><g><path d="m79.891 65.078 7.27-7.27C87.69 59.787 88 61.856 88 64c0 13.234-10.766 24-24 24-2.144 0-4.213-.31-6.192-.839l7.27-7.27a15.929 15.929 0 0 0 14.813-14.813zm47.605-3.021c-.492-.885-7.47-13.112-21.11-23.474l-5.821 5.821c9.946 7.313 16.248 15.842 18.729 19.602C114.553 71.225 95.955 96 64 96c-4.792 0-9.248-.613-13.441-1.591l-6.573 6.573C50.029 102.835 56.671 104 64 104c41.873 0 62.633-36.504 63.496-38.057a3.997 3.997 0 0 0 0-3.886zm-16.668-39.229-88 88C22.047 111.609 21.023 112 20 112s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656l11.196-11.196C10.268 83.049 1.071 66.964.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24c10.827 0 20.205 2.47 28.222 6.122l12.95-12.95c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656zM34.333 88.011 44.46 77.884C41.663 73.96 40 69.175 40 64c0-13.234 10.766-24 24-24 5.175 0 9.96 1.663 13.884 4.459l8.189-8.189C79.603 33.679 72.251 32 64 32 32.045 32 13.447 56.775 8.707 63.994c3.01 4.562 11.662 16.11 25.626 24.017zm15.934-15.935 21.809-21.809C69.697 48.862 66.958 48 64 48c-8.822 0-16 7.178-16 16 0 2.958.862 5.697 2.267 8.076z" fill="currentColor" opacity="1"></path></g></svg>}
                </div>}
                <div onClick={() => openAbsoluteMenuSectionSection(trace)}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.8313 4.66834L15.3313 2.16834C15.2434 2.08056 15.1242 2.03125 15 2.03125C14.8758 2.03125 14.7566 2.08056 14.6687 2.16834L7.16875 9.66834C7.08082 9.75616 7.03136 9.87531 7.03125 9.99959V12.4996C7.03125 12.6239 7.08064 12.7431 7.16854 12.831C7.25645 12.919 7.37568 12.9683 7.5 12.9683H10C10.1243 12.9682 10.2434 12.9188 10.3313 12.8308L17.8313 5.33084C17.919 5.24295 17.9683 5.12381 17.9683 4.99959C17.9683 4.87537 17.919 4.75623 17.8313 4.66834ZM9.80547 12.0308H7.96875V10.1941L13.125 5.03787L14.9617 6.87459L9.80547 12.0308ZM15.625 6.21131L13.7883 4.37459L15 3.16287L16.8367 4.99959L15.625 6.21131ZM17.3438 9.99959V16.2496C17.3438 16.5397 17.2285 16.8179 17.0234 17.023C16.8183 17.2281 16.5401 17.3433 16.25 17.3433H3.75C3.45992 17.3433 3.18172 17.2281 2.9766 17.023C2.77148 16.8179 2.65625 16.5397 2.65625 16.2496V3.74959C2.65625 3.45951 2.77148 3.18131 2.9766 2.97619C3.18172 2.77107 3.45992 2.65584 3.75 2.65584H10C10.1243 2.65584 10.2435 2.70522 10.3315 2.79313C10.4194 2.88104 10.4688 3.00027 10.4688 3.12459C10.4688 3.24891 10.4194 3.36814 10.3315 3.45604C10.2435 3.54395 10.1243 3.59334 10 3.59334H3.75C3.70856 3.59334 3.66882 3.6098 3.63951 3.6391C3.61021 3.6684 3.59375 3.70815 3.59375 3.74959V16.2496C3.59375 16.291 3.61021 16.3308 3.63951 16.3601C3.66882 16.3894 3.70856 16.4058 3.75 16.4058H16.25C16.2914 16.4058 16.3312 16.3894 16.3605 16.3601C16.3898 16.3308 16.4062 16.291 16.4062 16.2496V9.99959C16.4062 9.87527 16.4556 9.75604 16.5435 9.66813C16.6315 9.58022 16.7507 9.53084 16.875 9.53084C16.9993 9.53084 17.1185 9.58022 17.2065 9.66813C17.2944 9.75604 17.3438 9.87527 17.3438 9.99959Z" fill="currentColor" /></svg>
                </div>
            </div>
        </div>
    );
}

function CatalogueSearch(props: any) {

    const { mapSources, mapLayers, addMapSource, addMapLayer, setMapSources, setMapLayers, mapListEtape, setMapListEtape, addMapListEtape, traceStyle } = useContext(PageContext);


    const ref = useRef<HTMLDivElement>(null);
    const [depart, setDepart] = useState<any>(null);
    const [arrivee, setArrivee] = useState<any>(null);
    const [typeRecherche, setTypeRecherche] = useState<any>("tous");

    const fn = props.fn;

    function handleChange(value: any) {
        setTypeRecherche(value.target.value)
    }

    return (
        <div className="act-recherche">
            <p>Choisissez une course ou un road trip dans notre Catalogue : ​</p>
            <RadioGroup
                onChange={value => handleChange(value)}
                selectedValue={typeRecherche}
                className='radio-group-transport'
            >
                <Radio label="Tous" value="tous" />
                <Radio label="Sport" value="sport" />
                <Radio label="Voyage" value="voyage" />
            </RadioGroup>
        </div>
    );
}

